import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { fetchAbout } from '../api';
import './Footer.scss';

const Footer = () => {
    const [about, setAbout] = useState(null);

    // Contact + social links come from the About content singleton so the
    // footer always mirrors what the admin published.
    useEffect(() => {
        let cancelled = false;
        fetchAbout()
            .then((data) => { if (!cancelled) setAbout(data); })
            .catch(() => { /* footer degrades to legal links only */ });
        return () => { cancelled = true; };
    }, []);

    const contact = about?.contact;
    const socialLinks = about?.social_links ?? [];

    return (
        <footer className="site-footer" id="contact">
            <div className="container">
                <div className="row footer-contact">
                    <div className="col-12 text-center">
                        <h2 className="footer-title">Get in touch</h2>
                        {contact?.email && (
                            <a href={`mailto:${contact.email}`} className="footer-email">{contact.email}</a>
                        )}
                        {contact?.phone && (
                            <a href={`tel:${contact.phone.replace(/\s+/g, '')}`} className="footer-phone">{contact.phone}</a>
                        )}
                        {contact?.address && (
                            <p className="footer-address">{contact.address}</p>
                        )}
                        {socialLinks.length > 0 && (
                            <div className="footer-social">
                                {socialLinks.map((link, i) => (
                                    <a
                                        key={i}
                                        href={link.url}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        aria-label={link.platform}
                                        title={link.platform}
                                    >
                                        <span>{(link.platform || '?').charAt(0).toUpperCase()}</span>
                                    </a>
                                ))}
                            </div>
                        )}
                    </div>
                </div>

                <div className="footer-bottom">
                    <div className="row align-items-center">
                        <div className="col-12 col-md-6 footer-legal">
                            <Link to="/terms">Terms of Service</Link>
                            <Link to="/privacy">Privacy Policy</Link>
                            <Link to="/careers">Careers</Link>
                        </div>
                        <div className="col-12 col-md-6 footer-copyright">
                            <p>© {new Date().getFullYear()} Evib Group. All rights reserved.</p>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
